import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const NETWORK_KEY = "network";
const USER_KEY = "user";
const FUNDIT_KEY = "fundIt";
const STAX_KEY = "stax";
const FUND_IT_PERMISSION_KEY = "fundItPermissions";
const STATUS_KEY = "status";
const PERMISSIONS_KEY = "permissions";

export const flocknoteKeys = createKeys(featureKeys.FLOCKNOTE_FEATURE_KEY, {
  network: () => [NETWORK_KEY],
  user: () => [USER_KEY],
  fundItStatus: () => [FUNDIT_KEY, STATUS_KEY],
  fundItPermissions: () => [FUNDIT_KEY, FUND_IT_PERMISSION_KEY],
  staxStatus: () => [STAX_KEY, STATUS_KEY],
  permissions: () => [PERMISSIONS_KEY],
});
